import React, { Component, useEffect, useState, useRef } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom';
import { ApiService } from '../../containers/Services/apiservice';
import './style.css';
// import logo from '/logo.png';
let apiServices = new ApiService();
// const [login, setlogin] = useState(false);
const Header = () => {
  const [login, setlogin] = useState(false);
  const [name, setName] = useState('');
  const [themeData, setThemeData] = useState({ created_at: "", gs_address: "", gs_administration_email: "", gs_city: "", gs_email: "", gs_facebook_url: "", gs_fname: "", gs_id: 1, gram_url: "", gs_linkedin_url: "", gs_lname: "", gs_mobile: "", gs_password: "", gs_postcode: "", gs_site_address: "", gs_site_title: "", gs_state: "", gs_twitter_url: "", gs_youtube_url: "", site_favicon: "", site_logo: "", updated_at: "" });
  const [setlogo, setLogo] = useState('');
  const [setfavicon, setFavicon] = useState('');
  const [BankManApprove, setBankManApprove] = useState(0);
  const [HoldingUpload, setHoldingUpload] = useState(0);
  const [consentpath, setconsentpath] = useState(0);
  let history = useHistory();
  const location = useLocation();
  const didMountRef = useRef(true);
  useEffect(() => {
    if (didMountRef.current) {
      let data = (localStorage.getItem('AUTH_TOKEN'));
      if (data != null) {
        // if(location.pathname == "/investorconcent")
        // {
        //   setconsentpath(1);
        // }
        setlogin(true);
        const dataString = {
        }
        apiServices.getUserData(dataString).then(result => {
          if (result.data.status == 'success') {
            setconsentpath(result.data.data.gs_investor_concent_status)
            setBankManApprove(result.data.data.gs_epayezz_bankapprove)
            setHoldingUpload(result.data.data.gs_investor_concent_upload_status)
            if (result.data.data.gs_fname == null || result.data.data.gs_fname == '') {
              setName('Guest');
            } else {
              setName(result.data.data.gs_fname + " " + result.data.data.gs_lname);
            }
          }
          else if (result.data.status == "error" && result.data.message == "Session expired") {
            localStorage.removeItem('AUTH_TOKEN');
            alert(result.data.message)
            history.push("/login")
          }
          else {
            setName('USER');
          }
        })
          .catch(error => {
          })
      } else {
        setlogin(false);
      }
      apiServices.themeGetRequest().then(result => {
        console.log(result)
        if (result.data.status == 'success') {
          setThemeData(result.data.data);
          setLogo(result.data.logo_url);
          setFavicon(result.data.fav_icon_url);
        }})
        .catch(error => {
        })
    }
    didMountRef.current = false;
  }, []);
  const logout = () => {
    const dataString = {
   }
    if (window.confirm("Are You Sure You Want To Logout ?") == true) {
      apiServices.logoutPostRequest(dataString).then(res => {
        if (res.data.status == "success") {
          localStorage.removeItem('user');
          localStorage.removeItem('AUTH_TOKEN');
          history.push("/login");
        }
      })
    }
  }
  return (
    <div>
      <header className="site-header header-s1 is-sticky">
        <div className="topbar">
          <div className="container-fluid">
            <div className="row">
              <div className="col-lg-6">
                <ul className="social">
                  <li><a href={themeData.gs_facebook_url}><em className="fa fa-facebook"></em></a></li>
                  <li><a href={themeData.gs_twitter_url}><em className="fa fa-twitter"></em></a></li>
                  <li><a href={themeData.gs_linkedin_url}><em className="fa fa-linkedin"></em></a></li>
                  <li><a href={themeData.gs_instagram_url}><em className="fa fa-instagram"></em></a></li>
                </ul>
              </div>
              <div className="col-lg-6 al-right">
                <ul className="top-nav">
                  <li><a href="#">ARN No. 249633</a></li>
                  <li><a href="mailto:help@goalstox.com"><i className="fa fa-envelope-o" aria-hidden="true"></i> {themeData.gs_email}</a></li>
                  {themeData.gs_mobile != null ?
                    <li><a href="#"><i className="fa fa-mobile fa-lg"></i> {themeData.gs_mobile}</a></li> : ''
                  }
                  {
                    login == true ?
                      // <li>            
                      //   <span className="user-name fw600">Hi, {name} </span><span className="user-status"></span>
                      //   <span className="avatar"><img className="round" src="avatar.jpg" alt="avatar" width="25" height="25" /><span className="avatar-status-online"></span></span></li>  
                      <li> <div className="d-flex alter_nav_user">
                        <div className="dropdown dropdown-user pull-right">
                          <Link className="dropdown-toggle dropdown-user-link" to="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                            <div className="user-nav d-sm-flex d-none"><span className="user-name fw600">Hi, {name}</span><span className="user-status"></span></div>
                            <span className="avatar"><img className="round" src="/img/user.png" alt="avatar" width="25" height="25" /><span className="avatar-status-online"></span></span>
                          </Link>
                          <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                            <li><Link className="dropdown-item" to="/profile">My Profile</Link></li>
                            <li><Link className="dropdown-item" to="/subscription">My Orders</Link></li>
                            <li><Link className="dropdown-item" to="/changepassword">Change Password</Link></li>
                            <li><a onClick={logout} className="dropdown-item" href="javascript:void(0)">Logout</a></li>
                          </ul>
                        </div>
                      </div> </li>
                      :
                      <>
                        <li><Link to="/login"><i className="fa fa-sign-in" aria-hidden="true"></i> MFU Sign In </Link></li>
                        <li><a href="https://partner.goalstox.com/"><i className="fa fa-sign-in" aria-hidden="true"></i> Partner Sign In </a></li>
                        <li><a href="https://mfbsc.goalstox.com/"><i className="fa fa-sign-in" aria-hidden="true"></i> Sign In </a></li>
                        <li><a href="https://mfbsc.goalstox.com/signup.html">Sign Up</a></li>
                        {/* <li><Link to ="/login"><i className="fa fa-sign-in" aria-hidden="true"></i> Sign In </Link></li>
                        <li><Link to="/rwgisterintro">Sign Up</Link></li> */}
                      </>
                  }
                </ul>
              </div>
            </div>
          </div>
        </div>
        <nav className="navbar navbar-expand-lg">
          <div className="container-fluid">
            <Link className="navbar-brand" to="/"><img src="/img/logo.png" alt="logo" /></Link>
            <button className="navbar-toggler collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="menu_toggle">
                <span className="hamburger">
                  <span></span>
                  <span></span>
                  <span></span>
                </span>
                <span className="hamburger-cross">
                  <span></span>
                  <span></span>
                </span>
              </span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav ml-auto mb-2 mb-lg-0">
                {login == true ?
                  <>
                    <li className="nav-item "><Link className="nav-link " to="/dashboard">Dashboard</Link></li>
                    {/* {HoldingUpload == 1 ? */}
                    <li className="nav-item "><Link className="nav-link " to="/holdings">Portfolio</Link></li>
                    {/* :''} */}
                    {/* { BankManApprove == 1? 
             <>  */}
                    <li className="nav-item "><Link className="nav-link " to="/mutualfunds">Mutual fund</Link></li>
                    <li className="nav-item "><Link className="nav-link " to="/alltransactions">Transactions</Link></li>
                    {/* </>  :''
                } */}
                  </>
                  : <><li className="nav-item "><Link className="nav-link " to="/">Home</Link></li>
                  </>
                }
                <li className="nav-item "><Link className="nav-link " to="/about-us">About</Link></li>
                {/* <li className="nav-item "><Link className="nav-link " to="/product-pricing">Product &amp; Pricing</Link></li> */}
                <li className="nav-item"><Link className="nav-link " to="/blog">Blog</Link></li>
                <li className="nav-item"><Link className="nav-link " to="/contact">Contact</Link></li>
                {/* <li className="nav-item mitem"><Link className="nav-link " to="/login">MFU Sign In </Link></li> */}
                <li className="nav-item mitem"><a className="nav-link " href="https://partner.goalstox.com/">Partner Sign In </a></li>
              </ul>
            </div>
            {
              login == true ?
                <div className="alter_nav_user">
                  <div className="dropdown dropdown-user pull-right">
                    <Link className="dropdown-toggle dropdown-user-link" to="#" role="button" id="dropdownMenuLink" data-bs-toggle="dropdown" aria-expanded="false">
                      <div className="user-nav d-sm-flex d-none"><span className="user-name fw600">Hi, {name}</span><span className="user-status"></span></div>
                      <span className="avatar"><img className="round" src="/img/user.png" alt="avatar" width="40" height="40" /><span className="avatar-status-online"></span></span>
                    </Link>
                    <ul className="dropdown-menu" aria-labelledby="dropdownMenuLink">
                      <li><Link className="dropdown-item" to="/profile">My Profile</Link></li>
                      <li><Link className="dropdown-item" to="/subscription">Subscription</Link></li>
                      <li><Link className="dropdown-item" to="/changepassword">Change Password</Link></li>
                      <li><a href="javascript:void(0)" onClick={logout} className="dropdown-item">Logout</a></li>
                    </ul>
                  </div>
                </div> :
                <div className="alter_nav">
                  <a href="https://mfbsc.goalstox.com/">Sign In</a>
                  <a href="https://mfbsc.goalstox.com/signup.html">Sign Up</a>
                  {/* <Link to="/login" className="btn btn-outline-success me-2" type="button">Sign In / Sign Up</Link> */}
                </div>
            }
          </div>
        </nav>
      </header>
    </div>
  );
}
export default Header;